import { supabase } from '../../lib/supabase'

export const privacyPreferencesProvider = {
  async load(tenantId: string) {
    const [policies, events] = await Promise.all([
      supabase
        .from('consent_policy_registry')
        .select('purpose,data_category,policy_version,label_key,description_key,effective_at')
        .order('purpose'),
      supabase
        .from('consent_events')
        .select('tenant_id,user_id,purpose,data_category,policy_version,action,effective_at,created_at')
        .eq('tenant_id', tenantId)
        .order('effective_at', { ascending: false }),
    ])
    if (policies.error) return { data: null, error: policies.error }
    if (events.error) return { data: null, error: events.error }
    return { data: { policies: policies.data ?? [], events: events.data ?? [] }, error: null }
  },

  async decide(input: {
    tenantId: string
    purpose: string
    dataCategory: string
    policyVersion: number
    action: 'grant' | 'deny' | 'revoke'
    effectiveAt: string
    reason: string
    correlationId: string
  }) {
    return supabase.rpc('record_my_consent_decision', {
      p_tenant_id: input.tenantId,
      p_purpose: input.purpose,
      p_data_category: input.dataCategory,
      p_policy_version: input.policyVersion,
      p_action: input.action,
      p_effective_at: input.effectiveAt,
      p_reason: input.reason,
      p_correlation_id: input.correlationId,
    })
  },
}
